import {
  ListAuditRulesDocument,
  ListBoostBadgeCountsDocument,
  ListTransactionReviewItemsDocument,
  ListWorkItemsDocument,
  SummarizeWorkItemsDocument,
} from "@digits-graphql/frontend/graphql-bearer"

export const WORK_ITEM_STATE_CHANGE_REFETCH = [
  SummarizeWorkItemsDocument,
  ListBoostBadgeCountsDocument,
  ListAuditRulesDocument,
]

export const WORK_ITEMS_REFETCH = [
  ...WORK_ITEM_STATE_CHANGE_REFETCH,
  ListWorkItemsDocument,
  ListTransactionReviewItemsDocument,
]
